import axios, { CostHeaderParamsType, createCostHeader } from '@/shared/axios';
import { ThreadsPostDetailModelV1, ThreadsPostListModelV1 } from '@/types/threads';
import { BaseResponse } from '@/types/web.interface';

// /threads/post_detail/{postCode}
export async function getThreadsPostDetail(postCode: string, options?: CostHeaderParamsType) {
  const res = await axios.get<BaseResponse<ThreadsPostDetailModelV1>>(`/threads/post_detail/${postCode}`, {
    headers: createCostHeader(options),
  });
  return res.data;
}

// /threads/{username}/user_post
export async function getThreadsUserPostList(
  username: string,
  query: { existCode: string },
  options?: CostHeaderParamsType
) {
  const res = await axios.get<BaseResponse<ThreadsPostListModelV1>>(`/threads/${username}/user_post`, {
    params: query,
    headers: createCostHeader(options),
  });
  return res.data;
}
